import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import Alert from '@material-ui/lab/Alert';
import MaterialDialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';
import { fullDateNoPad } from 'Consts/DateFormats';
import MetaControl from 'Components/UI/Meta/MetaControl';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useResource from 'Hooks/useResource';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import { dispatchMeetingContextRefresh } from 'Hooks/useRefreshEvent';

const styles = theme => ({
  root: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
  },
  dialogSection: {
    marginTop: theme.spacing(4),
  },
  alert: {
    fontSize: '1em',
  },
  associatedMeetingPicker: {},
});

const RecategorizeEmailDialogContent = ({
  className,
  classes,
  closeModal,
  agendaResource,
}) => {
  const {
    resource,
    setAttribute: setAgendaResourceAttribute,
  } = useResource(agendaResource);
  const [submittingResource, setSubmittingResource] = useState(false);

  const { logEvent } = useEventTrackingLogEvent();

  const handleSubmit = async () => {
    if (submittingResource) {
      return;
    }
    try {
      setSubmittingResource(true);
      logEvent('Reassociated Email');
      await agendaResource.submit();
      closeModal();
      dispatchMeetingContextRefresh();
      displaySuccess('Successfully reassociated email.');
      setSubmittingResource(false);
    } catch (err) {
      displayErrorMessage(err, 'There was an issue reassociating this email.');
      setSubmittingResource(false);
    }
  };

  return (
    <MaterialDialogContent
      className={classNames(classes.root, className)}
      disableTypography
    >
      <Alert
        className={classes.alert}
        severity="info"
      >
        {`You are about to recategorize an email sent on ${moment(resource.attr('agendaSentTime')).format(fullDateNoPad)} titled:\n"${resource.attr('agendaSubject')}"`}
      </Alert>
      <div className={classes.dialogSection}>
        <MetaControl
          resource={resource}
          fullWidth
          attrName="newMeeting"
          onChange={(value) => {
            setAgendaResourceAttribute('newMeeting', value);
          }}
        />
      </div>
      <div className={classes.dialogSection}>
        <MetaControl
          resource={resource}
          fullWidth
          attrName="agendaMessageType"
          onChange={(value) => {
            setAgendaResourceAttribute('agendaMessageType', value);
          }}
        />
      </div>
      <div className={classes.dialogSection}>
        <Button
          color="secondary"
          disableElevation
          onClick={handleSubmit}
          variant="contained"
          disabled={submittingResource}
        >
          Submit
        </Button>
      </div>
    </MaterialDialogContent>

  );
};

RecategorizeEmailDialogContent.defaultProps = {
  className: '',
};

RecategorizeEmailDialogContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  agendaResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecategorizeEmailDialogContent);
